// extracted by mini-css-extract-plugin
module.exports = {"option":"_196cs2","noAnswer":"_2BQfcs","feedbackContainer":"Mbf6SK","fade-in":"L0E3Rp","questionLabel":"_9k9A95","explanation":"WZb_hW"};